<div class="input-group select-border stylish-input-group">
    <input
      id="filter-input-field"
      matInput
      [(ngModel)]="searchValue"
      (keyup)="applyFilter()"
      placeholder="{{ 'ORDER-LIST.FIELD-SEARCHBAR' | translate }} "
    />
    <button
    *ngIf="searchValue != ''"
    class="clear"
    (click)="clear()"
  ></button>
  </div>